<template>
  <div class="bb-timer-modal-delete">
    <i class="bbp-icon-cross bb-timer-modal-delete__close" @click="onClose"/>
    <div class="bb-timer-modal-delete__title">
      Do you really want to delete tracked time?
    </div>
    <div class="bb-timer-modal-delete-bottom">
      <button
        class="bbp-button bbp-button_border bbp-button_border_gray"
        @click="onClose"
      >
        cancel
      </button>
      <button
        class="bbp-button"
        @click="handlerClick"
      >
        {{ btnTextRight }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPTimerModalDelete',
  props: {
    btnTextRight: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    handlerClick () {
      this.$emit('handlerClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

.bb-timer-modal-delete {
  width: 520px;
  height: 213px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  border-radius: 8px;
  text-align: center;
  background: $color-white;
  position: relative;

  &__close {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 7px;
    right: 6px;
    font-size: 18px;
    color: $color-silver;
    transition: 0.15s;
    cursor: pointer;

    &:hover {
      color: $color-silver-chalice;
    }
  }

  &__title {
    margin: 70px 0 0 0;
    font-size: 15px;
    line-height: 18px;
    font-weight: 400;
  }
}

.bb-timer-modal-delete-bottom {
  height: 80px;
  border-top: 1px solid $color-mercury;
  background: $color-alabaster;
  position: sticky;
  bottom: 0;
  display: grid;
  grid-template-columns: repeat(2, 103px);
  grid-gap: 12px;
  justify-content: end;
  padding: 18px;
  border-top: 1px solid $color-mercury;
  background: $color-alabaster;
  border-radius: 0 0 8px 8px;

  .bbp-button {
    height: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalDelete.vue